import { Config } from '../com/config';
import { Util } from '../com/util';

class Index {

    constructor() {
        this.CONFIG = new Config();
        this.FORM = document.forms['optionsForm'];
        this.FORM_AGENCY_ID_IPT = this.FORM['agency_option[agency_id]'];
        this.FORM_APP_PAGE_TITLE_IPT = this.FORM['agency_option[application_page_title]'];
        this.FORM_CONTRACT_PDF_PL_REPL_IPT = this.FORM['agency_option[contract_pdf_paylight_replacement]'];
        this.FORM_DENTALS_THX_PL_REPL_IPT = this.FORM['agency_option[dentals_thx_pl_repl]'];
        this.DATASET_OPTION_BTN = 'data-target="#optionsModal';
        this.IS_JSON_AVAILABLE = true;

        this.AGENCIES_SEARCH_FORM = document.forms['agenciesSearchForm'];
        this.FORM_SEARCH = this.AGENCIES_SEARCH_FORM['search'];
    }


    closeModal() {
        const o = document.querySelector('button[data-dismiss="modal"]');
        if(o != null) {
            o.click();
        }
    }


    handleClkOptionBtn(elm) {
        this.FORM_AGENCY_ID_IPT.value = elm.dataset.id;
        this.FORM_APP_PAGE_TITLE_IPT.value = elm.dataset.title;
        this.FORM_CONTRACT_PDF_PL_REPL_IPT.value = elm.dataset.contractPdfPlRepl != null ? elm.dataset.contractPdfPlRepl : '';
        this.FORM_DENTALS_THX_PL_REPL_IPT.value = elm.dataset.dentalsThxPlRepl != null ? elm.dataset.dentalsThxPlRepl : '';
    }


    handleBeforeSend(e) {
        if(e.target.dataset.ujs === 'agency_option') {
            if(!this.IS_JSON_AVAILABLE) {
                return;
            }
            this.IS_JSON_AVAILABLE = false;
        }
        Util.DelDomValidateError();
    }


    handleSuccess(e) {
        if(e.target.dataset.ujs !== 'agency_option') {
            return;
        }
        const result = e.detail[0];
        const agencyId = result.agency_id;
        const elm = document.querySelector('[data-id="' + result.agency_id + '"]');
        if(elm != null) {
            elm.dataset.title = result.application_page_title;
            elm.dataset.contractPdfPlRepl = result.contract_pdf_paylight_replacement;
            elm.dataset.dentalsThxPlRepl = result.dentals_thx_pl_repl;
        }
        this.closeModal();
    }


    handleError(e) {
        if(e.target.dataset.ujs !== 'agency_option') {
            return;
        }
        if(e.detail[2] != null && e.detail[2].status === 401) {
            this.CONFIG.APP_MAIN.insertBefore(Util.GenFlashDanger(e.detail[0]), this.CONFIG.APP_MAIN.childNodes[0]);
            window.scrollTo(0,0);
            return;
        }
        const detail = e.detail[0];
        if(detail == null) {
            return;
        }
        const msg = detail.msg;
        if(msg != null && msg !== '') {
            this.CONFIG.APP_MAIN.insertBefore(Util.GenFlashDanger(msg), this.CONFIG.APP_MAIN.childNodes[0]);
        }
        if(e.target.dataset.ujs === 'agency_option') {
           const valid = detail.valid;
           if(valid != null) {
               if(valid['application_page_title'] != null && valid['application_page_title'][0] != null) {
                   Util.GenDomValidateError(this.FORM_APP_PAGE_TITLE_IPT, valid['application_page_title'][0]);
               }
               if(valid['contract_pdf_paylight_replacement'] != null && valid['contract_pdf_paylight_replacement'][0] != null) {
                   Util.GenDomValidateError(this.FORM_CONTRACT_PDF_PL_REPL_IPT, valid['contract_pdf_paylight_replacement'][0]);
               }
               if(valid['dentals_thx_pl_repl'] != null && valid['dentals_thx_pl_repl'][0] != null) {
                   Util.GenDomValidateError(this.FORM_DENTALS_THX_PL_REPL_IPT, valid['dentals_thx_pl_repl'][0]);
               }
           }
        }
    }


    handleComplete(e) {
        if(e.target.dataset.ujs === 'agency_option') {
            this.IS_JSON_AVAILABLE = true;
        }
    }


    setUpRailsUjsEventListener() {
        document.body.addEventListener('ajax:beforeSend', (e) => { this.handleBeforeSend(e); }, false);
        document.body.addEventListener('ajax:success', (e) => { this.handleSuccess(e); }, false);
        document.body.addEventListener('ajax:error', (e) => { this.handleError(e); }, false);
        document.body.addEventListener('ajax:complete', (e) => { this.handleComplete(e); }, false);
    }


    setUpClickEventListener() {
        const optionBtns = document.querySelectorAll('[' + this.DATASET_OPTION_BTN);
        for(let i = 0; i < optionBtns.length; i++) {
            const elm = optionBtns[i];
            elm.addEventListener('click', () => { this.handleClkOptionBtn(elm); }, false);
        }

        this.FORM_SEARCH.addEventListener('click', () => { this.AGENCIES_SEARCH_FORM.submit(); });
    }


    Run() {
        this.setUpRailsUjsEventListener();
        this.setUpClickEventListener();
    }

}
export { Index }
